var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('button',{staticClass:"btn add",attrs:{"type":"button","name":"button"}},[_vm._v("Add Card")])])}]

export { render, staticRenderFns }